import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './stats-overlay.module.css'

/** Frame timings, top left, while the `stats` command has them on. */
export function StatsOverlay() {
  const t = useT()
  const stats = useView((view) => view.dev.stats)
  if (!stats) return null
  const gpu =
    stats.gpuMs === null
      ? t(text('dev.stats.gpuNa'))
      : t(text('dev.stats.gpu', { ms: stats.gpuMs }))
  return (
    <p class={styles.stats}>
      {t(text('dev.stats.fps', { fps: stats.fps }))}
      {'\n'}
      {t(text('dev.stats.frame', { ms: stats.frameMs }))}
      {'  '}
      {gpu}
      {'\n'}
      {t(text('dev.stats.draws', { count: stats.drawCalls }))}
      {'  '}
      {t(text('dev.stats.meshes', { count: stats.activeMeshes }))}
      {'  '}
      {t(text('dev.stats.textures', { count: stats.textures }))}
    </p>
  )
}
